export const routesMedia = [
  {
    path: "/media",
    name: "media",
    component: () => import("@/views/media/index.vue"),
    meta: {
      public: false,
      title: "media.Medya",
      yetki: { k: [] }
    }
  }
]
